var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVollbildAus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.4775586,24.616752 L23.4775586,28.001752 L21.9815586,28.001752 L21.9815586,22.032752 L27.9815586,22.032752 L27.8965586,23.506752 L24.5155586,23.506752 L28.116207,26.6974258 L26.746207,28.0674258 L23.4775586,24.616752 Z M16.5192676,24.616752 L16.5192676,28.001752 L18.0152676,28.001752 L18.0152676,22.032752 L12.0152676,22.032752 L12.1002676,23.506752 L15.4812676,23.506752 L11.8806191,26.6974258 L13.2506191,28.0674258 L16.5192676,24.616752 Z M23.4775586,15.3545615 L23.4775586,11.9695615 L21.9815586,11.9695615 L21.9815586,17.9385615 L27.9815586,17.9385615 L27.8965586,16.4645615 L24.5155586,16.4645615 L28.116207,13.2738877 L26.746207,11.9038877 L23.4775586,15.3545615 Z M16.5192676,15.3545615 L16.5192676,11.9695615 L18.0152676,11.9695615 L18.0152676,17.9385615 L12.0152676,17.9385615 L12.1002676,16.4645615 L15.4812676,16.4645615 L11.8806191,13.2738877 L13.2506191,11.9038877 L16.5192676,15.3545615 Z",
    id: ".._.._src_svg_Icn_40px_Vollbild-Aus__path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Vollbild-Aus__Icn/40px/Vollbild-Aus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Vollbild-Aus__Color/20px/Platzhalter-Transparent",
    transform: "translate(10 10)",
    fillRule: "nonzero",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Vollbild-Aus__Rectangle",
    d: "M0 0H20V20H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: ".._.._src_svg_Icn_40px_Vollbild-Aus__mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#.._.._src_svg_Icn_40px_Vollbild-Aus__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: ".._.._src_svg_Icn_40px_Vollbild-Aus__Shape",
    xlinkHref: "#.._.._src_svg_Icn_40px_Vollbild-Aus__path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVollbildAus);
export default __webpack_public_path__ + "static/media/Vollbild-Aus.a74861ab7462c770ac0a6f6de6174434.svg";
export { ForwardRef as ReactComponent };